import { FIRST_FAVORITE_MODAL_VIEW } from './types';

export const triggerFirstFavoriteModalIsViewed = () => ({
  type: FIRST_FAVORITE_MODAL_VIEW,
});
